// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailConfigInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var EventUtils = require('EventUtils');
  var classnames = require('classnames');
  var observer = require('mobx-react').observer;
  var Validator = require('share/components/hoc/Izenda.Validator');
  var Input = require('share/components/controls/Izenda.Input');
  var ValidateInput = Validator()(require('share/components/controls/Izenda.Input'));
  var Numeric = Validator()(require('share/components/controls/Izenda.NumericInput'));
  var GridLayout = require('share/components/controls/Izenda.GridLayout');

  var REQUIRE_CONSTRAINTS = require('logic/data/Izenda.EmailConstants').REQUIRE_CONSTRAINTS;
  const { assign } = require('lodash/fp');

  var EmailConfigInput = function(props) {
    var type = props.type;
    var clazzName = classnames({ 'validation required': props.isRequired });

    return (
      <GridLayout.Row>
        <GridLayout.Col cols={3}>
          <label className={clazzName}>{props.title}</label>
        </GridLayout.Col>
        <GridLayout.Col cols={9}>{renderControl()}</GridLayout.Col>
      </GridLayout.Row>
    );

    function renderControl() {
      var InputControl = Input;
      var inputProps = {
        className: 'form-control',
        type: props.type,
        value: props.value,
        maxLength: 256,
        onChange: EventUtils.notifyChange(handleChange, EventUtils.INPUT)
      };
      if (props.isRequired) {
        InputControl = ValidateInput;
        inputProps = assign(inputProps, {
          field: props.dataKey,
          validations: REQUIRE_CONSTRAINTS
        });
      }

      if (type === 'checkbox') {
        return (
          <Input
            checked={props.value}
            type="checkbox"
            onChange={EventUtils.notifyChange(handleChange, EventUtils.CHECKBOX)}
          />
        );
      } else if (type === 'numeric') {
        return (
          <Numeric
            value={props.value}
            onChange={handleChange}
            field={props.dataKey}
            validations={REQUIRE_CONSTRAINTS}
          />
        );
      } else {
        return <InputControl {...inputProps} />;
      }
    }

    function handleChange(value) {
      props.onChange(props.dataKey, value);
    }
  };

  module.exports = observer(EmailConfigInput);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Email/Izenda.EmailConfigInput.jsx